export default function NotFoundPage() {
  document.title = "Vazron | 404 not found";
  return (
    <div className={`h-screen w-screen flex items-center justify-center`}>
      <div className="text-lg">Route NotFound 404</div>
    </div>
  );
}
